export default "__VITE_ASSET__fa6500c2__"